"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutWidget = void 0;
var react_1 = __importStar(require("react"));
var editorStyles = __importStar(require("./LayoutWidget.css"));
var publicStyles = __importStar(require("@CommonFrontend/Public/Widgets/Layout/Layout.css"));
var classnames_1 = __importDefault(require("classnames"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var SelectionRing_1 = require("Project/QwilrEditor/RegistryElement/SelectionRing");
var useSelectionState_1 = require("Project/QwilrEditor/RegistryElement/useSelectionState");
var LayoutContext_1 = require("./LayoutContext");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var AddedLayoutSizeSelector_1 = require("./AddedLayoutSizeSelector");
var AddedLayoutSizeSelector_css_1 = require("./AddedLayoutSizeSelector.css");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SyntheticSelection_1 = require("Project/SyntheticSelection");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var Router_1 = __importDefault(require("Project/QwilrEditor/Router"));
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var LayoutWidget = function (_a) {
    var _b;
    var _c;
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    var _d = (0, SelectionRing_1.useSelectionRingContext)(), mouseOverSelectableRegion = _d.mouseOverSelectableRegion, mouseOverWidget = _d.mouseOverWidget, setCustomRingColor = _d.setCustomRingColor;
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var _e = (0, LayoutContext_1.useLayoutContext)(), editMode = _e.editMode, setEditMode = _e.setEditMode;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var selectionStoreActions = (0, SyntheticSelection_1.useSelectionStoreActions)();
    var editor = (0, inversify_react_1.useInjection)(EditorTypes_1.SlateEditor.$);
    var router = (0, inversify_react_1.useInjection)(Router_1.default);
    var conversionElem = (0, inversify_react_1.useInjection)("conversionElem");
    var selected = ["multi", "circle"].includes(widgetSelectionState);
    var layoutRef = (0, react_1.useRef)(null);
    var gap = element.data.gap;
    var padding = element.data.padding;
    var alignment = element.data.alignment;
    var ignoreNextColumnFrameClick = (0, react_1.useRef)(false);
    var isInitialised = !element.isVoid;
    var _f = __read((0, react_1.useState)([]), 2), openColumnMenu = _f[0], setOpenColumnMenu = _f[1];
    var _g = __read((0, react_1.useState)(null), 2), resizingState = _g[0], setResizingState = _g[1];
    var resizingStateRef = (0, react_1.useRef)(null);
    var resizingGapIndex = (_c = resizingState === null || resizingState === void 0 ? void 0 : resizingState.gapIndex) !== null && _c !== void 0 ? _c : null;
    (0, react_1.useLayoutEffect)(function () {
        if (!layoutRef.current)
            return;
        layoutRef.current.style.display = "block";
        setTimeout(function () {
            if (!layoutRef.current)
                return;
            layoutRef.current.style.display = "";
        }, 0);
    }, []);
    (0, react_1.useEffect)(function () {
        if (editMode) {
            setCustomRingColor(tokens_1.palette.purple400);
        }
        else {
            setCustomRingColor(null);
        }
    }, [editMode, setCustomRingColor]);
    (0, react_1.useEffect)(function () {
        resizingStateRef.current = resizingState;
    }, [resizingState]);
    (0, react_1.useEffect)(function () {
        if (!isInitialised || !layoutRef.current)
            return;
        var _a = (0, observe_rect_1.default)(layoutRef.current, function (rect) {
            var _a;
            if (!layoutRef.current)
                return;
            (0, dynamic_1.setElementVars)(layoutRef.current, (_a = {}, _a[editorStyles.layoutWidth] = "".concat(rect.width, "px"), _a));
        }), observe = _a.observe, unobserve = _a.unobserve;
        observe();
        return unobserve;
    }, [isInitialised]);
    (0, react_1.useEffect)(function () {
        if (resizingGapIndex === null || layoutRef.current === null) {
            return;
        }
        var _a = layoutRef.current.getBoundingClientRect(), left = _a.left, width = _a.width;
        var columnWidth = (width - padding * 2 - (element.data.columns.length - 1) * gap) / 24;
        var startingNotch = element.data.columns.reduce(function (total, column, idx) { return (idx <= resizingGapIndex ? total + column.width : total); }, 0);
        var startingNotchX = left + padding + startingNotch * columnWidth + resizingGapIndex * gap + gap / 2;
        var mouseMoveListener = function (event) {
            var _a, _b;
            var fractionalDistance = (event.x - startingNotchX) / columnWidth;
            var attemptedNotchDistance = fractionalDistance < 0 ? Math.round(Math.abs(fractionalDistance)) * -1 : Math.round(fractionalDistance);
            var currentLeftColumnWidth = (_a = element.data.columns[resizingGapIndex]) === null || _a === void 0 ? void 0 : _a.width;
            var currentRightColumnWidth = (_b = element.data.columns[resizingGapIndex + 1]) === null || _b === void 0 ? void 0 : _b.width;
            (0, tiny_invariant_1.default)(currentLeftColumnWidth != null, "left column has no current width");
            (0, tiny_invariant_1.default)(currentRightColumnWidth != null, "right column has no current width");
            var distance = attemptedNotchDistance < 0
                ? Math.min(Math.abs(attemptedNotchDistance), currentLeftColumnWidth - 1) * -1
                : Math.min(attemptedNotchDistance, currentRightColumnWidth - 1);
            setResizingState({ gapIndex: resizingGapIndex, distance: distance });
        };
        var mouseUpListener = function () {
            setResizingState(null);
            if (resizingStateRef.current) {
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
                    action: "resizeColumn",
                    path: widgetManager.getPath(element),
                    columnIndex: resizingStateRef.current.gapIndex,
                    distance: resizingStateRef.current.distance,
                }));
            }
        };
        document.addEventListener("mousemove", mouseMoveListener);
        document.addEventListener("mouseup", mouseUpListener);
        return function () {
            document.removeEventListener("mousemove", mouseMoveListener);
            document.removeEventListener("mouseup", mouseUpListener);
        };
    }, [resizingGapIndex, element.data.columns, element, widgetManager]);
    var addColumn = function () {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "addColumn",
            path: widgetManager.getPath(element),
        }));
    };
    var addColumnAtIndex = function (index) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "addColumnAtIndex",
            path: widgetManager.getPath(element),
            addColumnAtIndex: index,
        }));
    };
    var moveColumn = function (currentColumnIndex, newColumnIndex) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "moveColumn",
            path: widgetManager.getPath(element),
            currentColumnIndex: currentColumnIndex,
            newColumnIndex: newColumnIndex,
        }));
    };
    var removeColumnAtIndex = function (index) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "removeColumnAtIndex",
            path: widgetManager.getPath(element),
            columnIndex: index,
        }));
    };
    var cloneColumn = function (index) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "cloneColumn",
            path: widgetManager.getPath(element),
            columnIndex: index,
        }));
    };
    var initialiseWithColumns = function (numberOfColumns) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "initialiseWithColumns",
            path: widgetManager.getPath(element),
            numberOfColumns: numberOfColumns,
        }));
        selectionStoreActions.setSelection([
            {
                path: widgetManager.getPath(element),
                editor: editor,
                router: router,
                conversionElem: conversionElem,
            },
        ]);
    };
    var columns = element.data.columns;
    if (!isInitialised) {
        return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, editorStyles.layout({ mouseOverSelectableRegion: mouseOverSelectableRegion, selected: selected })) }),
            react_1.default.createElement("div", { contentEditable: false },
                react_1.default.createElement(AddedLayoutSizeSelector_1.AddedLayoutSizeSelector, { selected: selected, initialiseWithColumns: initialiseWithColumns })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(AddedLayoutSizeSelector_css_1.LayoutSizeSelectorTextNodeWrapper) }, children)));
    }
    return (react_1.default.createElement("div", __assign({}, attributes, { "data-testid": "layout-widget", className: (0, classnames_1.default)(attributes.className, editorStyles.layoutWrapper), style: (0, dynamic_1.assignInlineVars)((_b = {},
            _b[publicStyles.layoutGap] = "".concat(gap, "px"),
            _b[publicStyles.layoutPadding] = "".concat(padding, "px"),
            _b[publicStyles.layoutAlignment] = alignment,
            _b[publicStyles.layoutColumnCount] = columns.length.toString(),
            _b)), onMouseDown: function (e) {
            if (editMode) {
                e.preventDefault();
            }
        }, onDragOver: function () {
            setEditMode(false);
        } }),
        react_1.default.createElement("div", { ref: layoutRef, className: (0, classnames_1.default)(publicStyles.layout, editorStyles.layout({
                mouseOverSelectableRegion: mouseOverSelectableRegion,
                selected: selected,
                editMode: editMode,
                fullWidth: (0, EditorWidgetRegistry_1.isResizeableWidget)(element) && element.data.width === "full",
            })) }, react_1.default.Children.map(children, function (child, idx) {
            var _a;
            var columnData = columns[idx];
            (0, tiny_invariant_1.default)(!!columnData, "no column data for column index ".concat(idx));
            var width = columnData.width;
            if (!!resizingState) {
                if (idx === resizingState.gapIndex) {
                    width += resizingState.distance;
                }
                else if (idx === resizingState.gapIndex + 1) {
                    width -= resizingState === null || resizingState === void 0 ? void 0 : resizingState.distance;
                }
            }
            var columnMenu = {
                isOpen: openColumnMenu.includes(idx),
                open: function () {
                    setOpenColumnMenu(__spreadArray(__spreadArray([], __read(openColumnMenu), false), [idx], false));
                },
                close: function () {
                    setOpenColumnMenu(openColumnMenu.filter(function (c) { return c !== idx; }));
                },
                toggle: function () {
                    if (openColumnMenu.includes(idx)) {
                        setOpenColumnMenu(openColumnMenu.filter(function (c) { return c !== idx; }));
                    }
                    else {
                        setOpenColumnMenu(__spreadArray(__spreadArray([], __read(openColumnMenu), false), [idx], false));
                    }
                },
            };
            return (react_1.default.createElement("div", { style: (0, dynamic_1.assignInlineVars)((_a = {},
                    _a[publicStyles.columnWidth] = width.toString(),
                    _a)), className: (0, classnames_1.default)(publicStyles.layoutColumn, editorStyles.layoutColumn) },
                idx < columns.length - 1 && (react_1.default.createElement("div", __assign({ contentEditable: false, className: editorStyles.gap({ editMode: editMode, resizing: (resizingState === null || resizingState === void 0 ? void 0 : resizingState.gapIndex) === idx }) }, (editMode
                    ? {
                        onMouseDown: function (e) {
                            e.stopPropagation();
                            setResizingState({ gapIndex: idx, distance: 0 });
                        },
                    }
                    : {})))),
                react_1.default.createElement("div", { className: editorStyles.layoutColumnContent({ editMode: editMode }) }, child),
                react_1.default.createElement("div", { className: editorStyles.columnFrame({
                        mouseOverWidget: mouseOverWidget,
                        selected: selected,
                        editMode: editMode,
                        isResizing: !!resizingState,
                    }), onMouseDown: function () {
                        ignoreNextColumnFrameClick.current = columnMenu.isOpen;
                    }, onClick: function () {
                        if (!ignoreNextColumnFrameClick.current) {
                            columnMenu.open();
                        }
                    } },
                    react_1.default.createElement("div", { contentEditable: false },
                        react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: editorStyles.layoutOptionMenu, isOpen: columnMenu.isOpen, onClose: function () {
                                setTimeout(function () {
                                    columnMenu.close();
                                }, 0);
                            }, button: react_1.default.createElement(kaleidoscope_1.IconButton, { tooltip: { content: "Click to open menu", offset: tokens_1.spacing.m }, className: editorStyles.columnToolbarButton({
                                    editMode: editMode,
                                    isOpen: columnMenu.isOpen,
                                    isResizing: !!resizingState,
                                }), onClick: columnMenu.toggle, icon: react_1.default.createElement(icons_1.OptionsHorizontal, null) }) },
                            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.InsertColumnLeft, null), disabled: columns.length === 12, onClick: function () { return addColumnAtIndex(idx); } }, "Add column left"),
                            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.InsertColumnRight, null), disabled: columns.length === 12, onClick: function () { return addColumnAtIndex(idx + 1); } }, "Add column right"),
                            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.ArrowLeft, null), disabled: idx === 0, onClick: function () { return moveColumn(idx, idx - 1); } }, "Move column left"),
                            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.ArrowRight, null), disabled: idx === react_1.default.Children.count(children) - 1, onClick: function () { return moveColumn(idx, idx + 1); } }, "Move column right"),
                            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Copy, null), disabled: columns.length === 12, onClick: function () { return cloneColumn(idx); } }, "Clone Column"),
                            react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
                            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { destructive: true, disabled: columns.length === 2, onClick: function () { return removeColumnAtIndex(idx); } }, "Delete column"))))));
        })),
        editMode ? (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Add, null), className: editorStyles.layoutAddColumnButton, size: kaleidoscope_1.ButtonSize.Small, disabled: columns.length === 12, disabledReason: "Can't add more than 12 columns", onClick: function () { return addColumn(); }, type: kaleidoscope_1.ButtonType.Secondary, tooltip: {
                content: "Add column",
                targetClassName: editorStyles.layoutAddButtonTooltipTarget,
            }, isRound: true, isIconOnly: true })) : null));
};
exports.LayoutWidget = LayoutWidget;
